import TableManager from "./TableManager";

export default TableManager;
